type TitleBlockProps = { isSubmitted: boolean };

const TitleBlock: React.FC<TitleBlockProps> = ({ isSubmitted }) => {
  return (
    <h1 className={`iris-title ${isSubmitted ? "iris-title--submitted" : ""}`}>
      CX Perspectives - your advanced contact centre analytics assistant.
    </h1>
  );
};

export default TitleBlock;
